export enum FarmSourceType {
  PAIR = 'PAIR',
  PORTFOLIO = 'PORTFOLIO',
}
